export const COMPANY_NAME = "Palmer Avenue, LLC";
export const COMPANY_SHORT = "Palmer Avenue";
export const COMPANY_INITIALS = "PA";
export const COMPANY_ADDRESS_FULL = "7232 Canby Ave Ste 7, Reseda, California, US 91335-8140";
export const COMPANY_LOCATION = "Reseda, California";
export const COMPANY_REGION = "Los Angeles County";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=7232%20Canby%20Ave%20Ste%207%2C%20Reseda%2C%20California%2C%20US%2091335-8140";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1611689342806-0863700ce1e4?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Profile", "value": "Public directory" },
  { "label": "Region", "value": "Los Angeles County" },
  { "label": "Location", "value": "Reseda, California" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "Palmer Avenue, LLC" },
  { "label": "Region", "value": "Los Angeles County" },
  { "label": "Address", "value": "7232 Canby Ave Ste 7, Reseda, California, US 91335-8140" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Directory profile", "body": "A concise public record for this organization." },
  { "icon": "✦", "title": "Public location", "body": "The address shown is the supplied public business location." },
  { "icon": "✿", "title": "Clear information", "body": "The page limits itself to verified directory details." },
  { "icon": "❍", "title": "Map access", "body": "Open the address in Google Maps for directions." },
];
